import { render, staticRenderFns } from "./ManualShiftBooking.vue?vue&type=template&id=28f97c8f&scoped=true"
import script from "./ManualShiftBooking.vue?vue&type=script&lang=js"
export * from "./ManualShiftBooking.vue?vue&type=script&lang=js"
import style0 from "./ManualShiftBooking.vue?vue&type=style&index=0&id=28f97c8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f97c8f",
  null
  
)

export default component.exports